// Common text constants shared across the application
// Centralized text management for easy localization and updates

export const COPYRIGHT_TEXT = '© 2025 Logitech. Reservados todos los derechos.';

export const storeNames = {
    fullh4rd: "Fullh4rd",
    insumosacuario: "Insumos Acuario",
    mercadolibre: "Tienda Oficial (MELI)",
    mexx: "MEXX",
    argenprint: "Argenprint",
    gamingcity: "Gaming City",
    compragamer: "Compragamer",
    ibeam: "Ibeam",
    tecnomas: "Tecnomas",
    mesajil: "Mesajil",
    memorykings: "Memory Kings",
    fabisan: "Fabisan",
    devercomp: "Devercomp",
    pamas: "Pamas",
    logitech: "Logitech Store",
    panamericana: "Panamericana",
    dobleclick: "Doble Click",
    alkosto: "Alkosto",
    crtech: "CR Tech",
    intelec: "Intelec",
    tikotek: "Ticotek",
    progaming: "Pro Gaming",
    spdigital: "SP Digital",
    ripley: "Ripley",
    tecnomarket: "Tecnomarket",
    mipc: "Mi PC",
    tauret: "Tauret",
    speedlogic: "Speed Logic",
    apcomputadores: "AP Computadores",
    falabella: "Falabella",
    gamecenter: "Game Center",
    phantom: "Phantom",
    hca: "HCA",
    achorao: "Achorao",
    gamingworld: "Gaming World",
    hiraoka: "Hiraoka",
    kingstore: "Kingstore",
    coolbox: "Coolbox",
    alcocerti: "Alcocerti",
} as const;